/**
 * Normalizes choice text for uniqueness comparison.
 * Performs case-insensitive, accent-insensitive, punctuation-insensitive comparison.
 *
 * @param {string} text - The text to normalize
 * @returns {string} The normalized text ready for comparison
 */
function normalizeChoiceText(text) {
  if (!text || typeof text !== 'string') {
    return ''
  }

  return text
    // Convert to lowercase
    .toLowerCase()
    // Normalize Unicode (NFD) and remove diacritics (combining marks)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    // Replace punctuation and special characters with spaces
    .replace(/[^\w\s]/g, ' ')
    // Normalize whitespace: trim and collapse multiple spaces to single space
    .trim()
    .replace(/\s+/g, ' ')
}

module.exports = {
  normalizeChoiceText
}






